<template>
<div class="ViewAdaptiveGameElementOverlay">
  <div class="container-fluid">
    <div id="myNav" class="overlay overlay-overall-width-100Perc">
      <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
        <div class="row margin-left-1Point6Perc">
          <div class="col-md-7 col-lg-7 text-align-left padding-top-2Perc create-element-overlay-course-title-font-styles">
            {{getCurrentlySelectedCourseObj.CourseTitle}}
          </div>    
          <div class="col-md-5 col-lg-5">
            <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer" v-on:click="closeOverlay">
              <img src= "../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
            </div>  
          </div>
        </div>
        <div class="row margin-left-1Point5Perc">
          <div class="col-md-12 col-lg-12 text-align-left font-wight-bold create-element-overlay-module-title-font-styles">
            {{getLessonObj.Title}}
          </div>    
        </div>
        <div class="row margin-left-1Point5Perc padding-bottom-1Perc margin-bottom-2Perc">
          <div class="col-md-12 col-lg-12 text-align-left bottom-border orange-text-color">
            {{getElementObj.Title}}
          </div>
        </div>
        <div class="row container-fluid">
          <div class="col-md-12 col-lg-12">
            <div class="left-border top-border right-border container-fluid padding-top-15px padding-bottom-15px">
             <span v-if="currDisplayText" class="col-md-4 col-lg-4 font-size-19px margin-bottom-0px text-align-left padding-Left-0px">{{currDisplayText}}</span>
             <span v-else class="col-md-4 col-lg-4 font-size-19px margin-bottom-0px text-align-left padding-Left-0px">{{currDisplayText}}       
             </span>
            </div>
          </div>
        </div>
        <div class="row container-fluid">
          <div class="col-md-12 col-lg-12 container-fluid">
            <div class="border-bottom-1px">
              <adaptive-game-show-path v-for="(currPath,index) in getCurrentGamePath" :key="index" :currPath="currPath" :currIndex="index"></adaptive-game-show-path>
            </div>
          </div>
        </div>
        <!-- <a :href="this.getElementObj.FileUrl">
          <div class="row padding-top-1Perc background-color-div font-color-white margin-right-0px margin-left-0px" v-html="linkText">
          </div>
        </a> -->
        <div class="row height-15px">
          <div class="col-md-12 col-lg-12 ">

          </div>
        </div> 
      </div>
    </div>
 </div>
 </div>
</template>

<script>
import AdaptiveGameShowPath from '@/components/adaptive_game/AdaptiveGameShowPath'
import { elementService } from '@/server-util/element-service'
import { constants } from '@/utils/constants'
export default {
  props: ['elementObj', 'lessonObj'],
  created: function () {
    this.getAdaptiveGamePathFromServer()
  },
  data: function () {
    return {
      linkText: '',
      currGamePathArr: [],
      currDisplayText: ''
    }
  },
  name: 'ViewVideoElementOverlay',
  methods: {
    closeOverlay: function () {
      var obj = {
        closeOverlay: false,
        isUpdated: false
      }
      this.$emit('closeOverlay', obj)
    },
    setDefaultValues: function () {
      if (this.getElementObj.LinkText !== null && this.getElementObj.LinkText !== 'null' && this.getElementObj.LinkText !== undefined) {
        var originalLinkText = this.getElementObj.LinkText
        var firstOccuranceIndex = originalLinkText.indexOf('*')
        var lastOccuranceIndex = originalLinkText.lastIndexOf('*')
        var starText = originalLinkText.slice(firstOccuranceIndex + 1, lastOccuranceIndex)

        var regexStarText = /\*([^*]*)\*/
        this.linkText = originalLinkText.replace(regexStarText, '<font color=#f39c12> ' + starText + '</font>')
      }
    },
    getAdaptiveGamePathFromServer: function () {
      var _this = this
      var storeObj = this.$store
      var serverResponse = null
      if (_this.getElementObj !== undefined && _this.getElementObj !== '' && _this.getElementObj !== null) {
        _this.$store.state.isLoading = true
        elementService
          .getAdaptiveGamePath(storeObj.state.access_token, _this.getElementObj.ElementId)
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                serverResponse = responseObj.data
                console.log('getAdaptiveGamePathFromServer >> ' + JSON.stringify(serverResponse))
                _this.showStepCreationUI = true
                if (serverResponse !== undefined && serverResponse !== null && serverResponse !== '' && serverResponse.length !== 0) {
                  _this.currGamePathArr = serverResponse
                  _this.showGamePath = true
                  _this.currDisplayText = 'Learning Game Path(s):'
                } else {
                  _this.showGamePath = false
                  _this.currDisplayText = 'No Learning Game Paths(s) Found'
                }
                _this.$store.state.isLoading = false
              } else {
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
              }
            },
            errorObj => {
              _this.showAlertDialog = true
              _this.$store.state.isLoading = false
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'Selected Element Object is NULL hence declined GET ADAPTIVE GAME SUB-STEP(s)'
        )
      }
    }
  },
  components: {
    'adaptive-game-show-path': AdaptiveGameShowPath
  },
  computed: {
    getCurrentlySelectedCourseObj: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter
      }
    },
    getLessonObj: {
      get: function () {
        return this.lessonObj
      }
    },
    getElementObj: {
      get: function () {
        return this.elementObj
      }
    },
    getCurrentGamePath: {
      get: function () {
        return this.currGamePathArr
      }
    }
  }
}
</script>

<style scoped>
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.margin-right-3Perc {
  margin-right: 3%;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.ViewVideoElementOverlay {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
a {
  text-decoration: none !important;
  color: #fff !important;
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-0Point5Perc
{
    margin-left:0.5%;
}
.margin-left-1Perc
{
    margin-left:1%;
}
.margin-left-1Point5Perc
{
    margin-left:1.5%;
}
.margin-left-1Point6Perc
{
    margin-left:1.6%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}
.top-border
{
  border-top: 1px solid #aaa;
}
.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 10%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
  height: auto !important;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000 !important;
}
.red-border{
  border:1px solid red;
}
.align-center {
    margin: auto;
    /* width: 50%; */
    /* border: 3px solid green; */
    /* padding: 10px; */
}
.background-color-div{
  background-color: rgb(0, 0, 0,0.75);
}
.margin-left-0px{
  margin-left: 0px;
}
.margin-right-0px{
  margin-right: 0px;
}
.font-color-white{
  color:white;
}
.font-styles {
  font-size: 20px;
  color: #34495e;
  font-weight: bold;
}
.margin-left-30px{
  margin-left:30px;
}
.padding-left-0Perc{
  padding-left: 0%
}
.padding-top-1Perc{
  padding-top:1%;
}
.padding-top-2Perc{
  padding-top:2%;
}
.padding-bottom-2Perc{
  padding-bottom:2%;
}
.video-width{
  width: 85% !important;
  height:25% !important;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.orange-text-color {
 color: #f39c12 !important;
}
.border-red {
    border: 1px solid red;
}
.right-border {
  border-right: 1px solid #aaa;
}
.padding-top-15px {
 padding-top:15px; 
}
.padding-bottom-15px {
  padding-bottom:15px;
}
.border-bottom-1px {
  border-bottom:1px solid #aaa;
}
.height-15px {
  height:15px;
}
.font-size-19px {
  font-size:19px;
}
</style>



// WEBPACK FOOTER //
// src/components/view_element/ViewAdaptiveGameElementOverlay.vue